import { SnackbarProvider } from 'notistack';
import { useMemo } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { enUS } from 'date-fns/locale/en-US';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Provider } from 'react-redux';
import AppContext from '@/contexts/AppContext';
import { FuseSettingsProvider } from '@fuse/core/FuseSettings/FuseSettingsProvider';
import { I18nProvider } from '@i18n/I18nProvider';
import store from '@/store/store';
import MainThemeProvider from '@/contexts/MainThemeProvider';
import NavigationLoader from '@/components/theme-layouts/components/navigation/NavigationLoader';
import PlanSync from '@/components/PlanSync';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Outlet } from 'react-router-dom';

/**
 * AppProviders - Wraps all providers that need Router context
 * This component is used inside RouterProvider so useLocation() works
 */
export default function AppProviders() {
	const val = useMemo(() => ({}), []);

	return (
		<AppContext.Provider value={val}>
			{/* Date Picker Localization Provider */}
			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				adapterLocale={enUS}
			>
				{/* Redux Store Provider */}
				<Provider store={store}>
					<FuseSettingsProvider>
						<I18nProvider>
							{/* Theme Provider */}
							<MainThemeProvider>
								{/* Notistack Notification Provider */}
								<SnackbarProvider
									maxSnack={5}
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'right'
									}}
									classes={{
										containerRoot: 'bottom-0 right-0 mb-13 md:mb-17 mr-2 lg:mr-20 z-99'
									}}
								>
									<ToastContainer
										position="top-right"
										autoClose={3000}
										hideProgressBar={false}
										newestOnTop={false}
										closeOnClick
										rtl={false}
										pauseOnFocusLoss
										draggable
										pauseOnHover
										theme="light"
									/>
									<PlanSync />
									<NavigationLoader />
									<Outlet />
								</SnackbarProvider>
							</MainThemeProvider>
						</I18nProvider>
					</FuseSettingsProvider>
				</Provider>
			</LocalizationProvider>
		</AppContext.Provider>
	);
}

